import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/EventLog/";
    return {
        LogEvent(request) {
            var url = baseUrl + "LogEvent";
            return Proxy.PostVoid(url, request);
        },
    };
})()